/**
 * PCB Rule Set Action Creators
 *
 * This file contains action creators for PCB rule set operations.
 * These are pure functions that create action objects - they don't depend on Redux runtime.
 */

import {PcbRulesMap, PcbRuleSetsMap, createActionRecordAction} from "@buildwithflux/core";

// Re-export toggleGlobalPcbRule from the shared package
export {toggleGlobalPcbRule} from "@buildwithflux/frontend-e2e-shared";

// ============================================================================
// addGlobalRulesFromClipboard
// ============================================================================

export const addGlobalRulesFromClipboard = createActionRecordAction(
    "addGlobalRulesFromClipboard",
    (targetObjectUids: string[], nodeLayoutRules: PcbRulesMap) => {
        return {
            payload: {
                targetObjectUids,
                nodeLayoutRules,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
                // NOTE: assume the worst for baking
                hasInheritedRules: true,
                hasInheritedCalculations: true,
                requiresDescendantRebake: true,
                requiresNetDescendantRebake: true,
            },
        };
    },
    "pasted layout rules",
);

// ============================================================================
// duplicateGlobalPcbRuleSet
// ============================================================================

export const duplicateGlobalPcbRuleSet = createActionRecordAction(
    "duplicateGlobalPcbRuleSet",
    (ruleUids: string[]) => {
        return {
            payload: {
                ruleUids,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
            },
        };
    },
    "duplicates a pcb layout rule",
);

// ============================================================================
// removeGlobalPcbRuleSet
// ============================================================================

export const removeGlobalPcbRuleSet = createActionRecordAction(
    "removeGlobalPcbRuleSet",
    (pcbLayoutRuleUids: string[]) => {
        return {
            payload: {
                pcbLayoutRuleUids,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
            },
        };
    },
    "removed project pcb layout rules",
);

// ============================================================================
// setGlobalPcbRuleSet
// ============================================================================

export const setGlobalPcbRuleSet = createActionRecordAction(
    "setGlobalPcbRuleSet",
    (setPcbLayoutRules: PcbRuleSetsMap, selectedGlobalPcbLayoutRule?: string) => {
        return {
            payload: {
                setPcbLayoutRules,
                selectedGlobalPcbLayoutRule,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
            },
        };
    },
    "added or updated project pcb layout rules",
);
